import "../../_core/scripts/specific/layout/index";
import {initDiaporama} from "../../components/diaporama/diaporama";
import {initProductInformation} from "../../components/tabsProduct/tabsProduct";
import {initOrxAccordion} from "../../components/orxapiwidgetanimation/widget/accordion/accordion";
import {initBookingPrice, initScrollLink} from "../../components/bookingStickyPrice/bookingStickyPrice";
import {initOrxPopin} from "../../components/popin/popin";
import {initBtnSharePopin} from "../../components/headerProduct/headerProduct";
import {initBtnPromotePopin} from "../../components/promotePdt/promotePdt";
import {initBookingEngineComponent} from "../../_core/scripts/specific/bookingEngine/components";
import {initBtnVideoPopin} from "../../components/diaporamaProduct/diaporamaProduct";
import {initUserLogout} from "../../components/breadcrumb/breadcrumb";
import {initMainSearch} from "../../components/mainNav/mainNav";
import {initSendMail} from "../../components/popinShare/popinShare";
import {initOrxPopinVideo} from "../../components/popinVideo/popinVideo";
import {initSliderFullPackage} from "../../components/headerProduct/headerCountdown";
import {initInformationsProduct} from "../../components/informationsProduct/informationsProduct";
import {setCanalFromUrl} from "../../_core/scripts/specific/tools/Booking";

if (console !== undefined) {
    console.log("initialize package 😊");
}

initBookingPrice();
initBookingEngineComponent();
initDiaporama(".product-style", "package");
initDiaporama(".thumbnails-style", "packageThumbs");
initDiaporama(".similar-style", "packageSimilar");
initProductInformation();
initInformationsProduct();
initOrxAccordion();
// initElemCustomSelect();
initScrollLink();
// initShowBtnStickyPrice();
initOrxPopin();
initBtnSharePopin();
initBtnPromotePopin();
initBtnVideoPopin();
initMainSearch();
initSendMail();
initOrxPopinVideo();
initUserLogout();
initSliderFullPackage();
setCanalFromUrl();
